interface DeviceThumbProps {
  imageUrl?: string;
  alt: string;
  className?: string;
}

export function DeviceThumb({ imageUrl, alt, className = '' }: DeviceThumbProps) {
  return (
    <div
      className={`rounded-xl2 bg-surface-700 overflow-hidden flex items-center justify-center ${className}`}
    >
      {imageUrl ? (
        <img src={imageUrl} alt={alt} className="w-full h-full object-cover" />
      ) : (
        <span className="text-neutral-500 text-xs">No image</span>
      )}
    </div>
  );
}
